import styled from '@emotion/styled'
import React from 'react'

import ModalManager from './ModalManager'
import { Modals } from 'lib/store'

const Title = styled.h1`
	${({ theme }) => theme.typography.captionMedium};
	margin: 0;
`

const Caption = styled.p`
	${({ theme }) => theme.typography.caption};
	margin-top: ${({ theme }) => theme.spaces.space3};
	margin-bottom: ${({ theme }) => theme.spaces.space7};
`

const ButtonsContainer = styled.div`
	display: flex;
	gap: ${({ theme }) => theme.spaces.space3};
	justify-content: flex-end;
`

type Props = {
	children: React.ReactNode
	title: string
	caption: string | React.ReactNode
	hideModal: () => void
	name: Modals
}

function ConfirmationModal({ title, caption, hideModal, name, children, ...restProps }: Props) {
	return (
		<ModalManager modalName={name} hideModal={hideModal} {...restProps}>
			<Title>{title}</Title>
			<Caption>{caption}</Caption>
			<ButtonsContainer>{children}</ButtonsContainer>
		</ModalManager>
	)
}

export default ConfirmationModal
